import { createFileRoute } from "@tanstack/react-router";

import { NotificationsListPerAccount } from "@/components/Notifications/account/component.tsx";
import {
  useBreadCrumbItems,
  useNotificationTableData,
} from "@/components/Notifications/account/hooks.tsx";

const AccountNotificationsView = () => {
  // eslint-disable-next-line no-use-before-define
  const { id } = Route.useParams();

  return (
    <NotificationsListPerAccount
      id={id}
      useBreadCrumbItems={useBreadCrumbItems}
      useNotificationTableData={useNotificationTableData}
    />
  );
};

export const Route = createFileRoute("/account/$id/notifications/")({
  component: AccountNotificationsView,
});
